import React from "react";
import { useEffect } from "react";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import { useDispatch, useSelector } from "react-redux";
import updateNotesActions from "../../_actions/updateNotesActions";

export default function UpdateNotes(props) {
  const dispatch = useDispatch();
  useEffect(() => dispatch(updateNotesActions.getLatest()), []);
  const latestUpdateNotes = useSelector((state) => state.updateNotes.latest || "");

  return (
    <div className="card m-2">
      <div className="card-body">
        <ReactMarkdown>{latestUpdateNotes}</ReactMarkdown>
      </div>
    </div>
  );
}
